import { datadogRum } from '@datadog/browser-rum';
import {
    DATADOG_APPLICATION_ID,
    DATADOG_CLIENT_TOKEN,
    DATADOG_SITE,
    DATADOG_SESSION_SAMPLE_RATE,
    DATADOG_SESSION_REPLAY_SAMPLE_RATE,
} from '../const/environments.constants';
import { IUser } from '../interfaces/user.interface';
import { IWorkspace } from '../interfaces/workspace.interface';

if (DATADOG_APPLICATION_ID && DATADOG_CLIENT_TOKEN) {
    datadogRum.init({
        applicationId: DATADOG_APPLICATION_ID,
        clientToken: DATADOG_CLIENT_TOKEN,
        site: DATADOG_SITE,
        service: 'smallveries-dashboard',
        env: process.env.REACT_APP_ENV || 'development',
        sessionSampleRate: Number(DATADOG_SESSION_SAMPLE_RATE),
        sessionReplaySampleRate: Number(DATADOG_SESSION_REPLAY_SAMPLE_RATE),
        trackUserInteractions: true,
        trackResources: true,
        defaultPrivacyLevel: 'mask-user-input',
    });
}

const validateDatadogInit = () => {
    if (!DATADOG_APPLICATION_ID || !DATADOG_CLIENT_TOKEN) {
        return false;
    }

    return true;
};

export const trackUserDatadog = (user: Partial<IUser>, workspace: Partial<IWorkspace>) => {
    if (!validateDatadogInit()) return;

    datadogRum.setUser({
        id: user._id,
        name: `${user.name ?? ''} ${user.lastName ?? ''}`.trim(),
        email: user.email ?? '',
    });

    datadogRum.setGlobalContextProperty('workspace', {
        id: workspace._id,
        name: workspace.name,
        keyName: workspace.keyName,
    });
};

export const clearDatadogIdentity = () => {
    if (!validateDatadogInit()) return;

    datadogRum.clearUser();
    datadogRum.removeGlobalContextProperty('workspace');
};

export const addDatadogError = (error: Error, context?: Record<string, unknown>) => {
    if (!validateDatadogInit()) return;

    datadogRum.addError(error, context);
};
